import { render, staticRenderFns } from "./CompanyDetailMenu.vue?vue&type=template&id=330446c8&"
import script from "./CompanyDetailMenu.vue?vue&type=script&lang=js&"
export * from "./CompanyDetailMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports